import NewsTipCommentsList from './NewsTipCommentsList'

export default NewsTipCommentsList
